import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Menu,
  MultiSelect,
  Select,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import {
  IconBrandBootstrap,
  IconBuildingSkyscraper,
  IconCheck,
  IconDots,
  IconEdit,
  IconPlus,
  IconSearch,
  IconTrash,
  IconUser,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { UserMenuGroup } from "../../../model/UserMenuGroup";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

const DecentralizationReport = ({
  code,
  name,
}: {
  code: string;
  name: string;
}) => {
  //#region  table
  const headerRef = React.useRef<HTMLDivElement>(null);
  //data and fetching state
  const [data, setData] = useState<UserMenuGroup[]>([]);
  const [dataTemp, setDataTemp] = useState<UserMenuGroup[]>([]);

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [height, setHeight] = useState(0);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 50,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  //Search
  const [keySearch, setKeySearch] = useDebouncedState("", 300);
  const [search, setSearch] = useState<any>({});
  const [dataSubmit, setDataSubmit] = useState<any>({});
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [selectIds, setSelectIds] = useState<string[]>([]);

  const [deleteViewStatus, setDeleteViewStatus] = useState(0);

  const [dataEmployee, setDataEmployee] = useState<ComboboxItem[]>([]);
  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);
  const [dataDepartment, setDataDepartment] = useState<ComboboxItem[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "PQBC",
        Header: () => (
          <Badge
            size="md"
            variant="gradient"
            gradient={{ from: "blue", to: "cyan", deg: 90 }}
          >
            {name}
          </Badge>
        ),
        columns: [
          {
            accessorKey: "empName",
            header: "Nhân viên",
            Cell: ({ row }) => (
              <Text fw={500} size="12.5px">
                {row.original.empCode} - {row.original.empName}
              </Text>
            ),
            Edit: ({ row, column, table }) => {
              return (
                <Select
                  placeholder="Tên nhóm"
                  data={dataEmployee}
                  value={String(dataSubmit.empId)}
                  comboboxProps={{ width: 225 }}
                  searchable
                  clearable
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                  onChange={(e) =>
                    setDataSubmit((prev: any) => ({
                      ...prev,
                      empId: e ? Number(e) : 0,
                    }))
                  }
                />
              );
            },
          },
          {
            accessorKey: "listBranchId",
            header: "Danh sách chi nhánh",
            Cell: ({ row }) =>
              row.original.listBranchId &&
              row.original.listBranchId?.length > 0 ? (
                <Flex gap={"xs"} align={"center"}>
                  {row.original.listBranchId
                    ?.split(",")
                    ?.filter((item: any) => item !== "-1")
                    ?.slice(0, 3)
                    ?.map((item: any) => (
                      <Badge variant="light">
                        {getValueById(item, dataBranch, "label")}
                      </Badge>
                    ))}
                  {row.original.listBranchId?.split(",")?.length > 3 ? (
                    <Menu width={500}>
                      <Menu.Target>
                        <Tooltip label="Xem thêm">
                          <ActionIcon variant="light" radius={"lg"}>
                            <IconDots size={18} />
                          </ActionIcon>
                        </Tooltip>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Flex gap={"xs"} wrap={"wrap"} justify={"center"}>
                          {row.original.listBranchId
                            ?.split(",")
                            ?.filter((item: any) => item !== "-1")
                            ?.slice(
                              3,
                              Number(
                                row.original.listBranchId
                                  ?.split(",")
                                  ?.filter((item: any) => item !== "-1")
                                  ?.length,
                              ),
                            )
                            ?.map((item: any) => (
                              <Badge variant="light">
                                {getValueById(item, dataBranch, "label")}
                              </Badge>
                            ))}
                        </Flex>
                      </Menu.Dropdown>
                    </Menu>
                  ) : (
                    <></>
                  )}
                </Flex>
              ) : (
                <></>
              ),
            Edit: ({ row }) => (
              <MultiSelect
                placeholder="Nhập mã chi nhánh"
                data={dataBranch}
                value={dataSubmit?.listBranchId}
                clearable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                searchable
                onChange={(e) => {
                  if (e?.includes("-1")) {
                    setDataSubmit((prev: any) => ({
                      ...prev,
                      listBranchId: dataBranch
                        ?.filter((item) => item.value !== "-1")
                        ?.map((item) => item.value),
                    }));
                  } else {
                    setDataSubmit((prev: any) => ({
                      ...prev,
                      listBranchId: e ? e : [],
                    }));
                  }
                }}
              />
            ),
          },
          {
            accessorKey: "listDepartmentId",
            header: "Danh sách phòng ban",
            Cell: ({ row }) =>
              row.original.listDepartmentId &&
              row.original.listDepartmentId?.length > 0 ? (
                <Flex gap={"xs"} align={"center"}>
                  {row.original.listDepartmentId
                    ?.split(",")
                    ?.filter((item: any) => item !== "-1")
                    ?.slice(0, 3)
                    ?.map((item: any) => (
                      <Badge variant="light" color="green">
                        {getValueById(item, dataDepartment, "label")}
                      </Badge>
                    ))}
                  {row.original.listDepartmentId?.split(",")?.length > 3 ? (
                    <Menu width={500}>
                      <Menu.Target>
                        <Tooltip label="Xem thêm">
                          <ActionIcon
                            variant="light"
                            radius={"lg"}
                            color="green"
                          >
                            <IconDots size={18} />
                          </ActionIcon>
                        </Tooltip>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Flex
                          gap={"xs"}
                          wrap={"wrap"}
                          justify={"center"}
                          w={"100%"}
                        >
                          {row.original.listDepartmentId
                            ?.split(",")
                            ?.filter((item: any) => item !== "-1")
                            ?.slice(
                              3,
                              Number(
                                row.original.listDepartmentId
                                  ?.split(",")
                                  ?.filter((item: any) => item !== "-1")
                                  ?.length,
                              ),
                            )
                            ?.map((item: any) => (
                              <Badge variant="light" color="green">
                                {getValueById(item, dataDepartment, "label")}
                              </Badge>
                            ))}
                        </Flex>
                      </Menu.Dropdown>
                    </Menu>
                  ) : (
                    <></>
                  )}
                </Flex>
              ) : (
                <></>
              ),
            Edit: ({ row }) => (
              <MultiSelect
                placeholder="Nhập phòng ban"
                data={dataDepartment}
                value={dataSubmit?.listDepartmentId}
                searchable
                onChange={(e) => {
                  if (e?.includes("-1")) {
                    setDataSubmit((prev: any) => ({
                      ...prev,
                      listDepartmentId: dataDepartment
                        ?.filter((item) => item.value !== "-1")
                        ?.map((item) => item.value),
                    }));
                  } else {
                    setDataSubmit((prev: any) => ({
                      ...prev,
                      listDepartmentId: e ? e : [],
                    }));
                  }
                }}
              />
            ),
          },
          {
            accessorKey: "action",
            header: "Thao tác",
            size: 80,
            enableEditing: false,
            enableColumnActions: false,
            enableColumnFilter: false,
            enableSorting: false,
            Cell: ({ row, table }) => (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <Tooltip label="Chỉnh sửa">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="orange"
                    onClick={() => {
                      setIsEdit(true);
                      table.setEditingRow(row);
                      setDataSubmit({
                        ...row.original,
                        listBranchId: row.original?.listBranchId
                          ?.split(",")
                          ?.filter((item: any) => item !== "-1")
                          ?.map((item: any) => String(item)),
                        listDepartmentId: row.original?.listDepartmentId
                          ?.split(",")
                          ?.filter((item: any) => item !== "-1")
                          ?.map((item: any) => String(item)),
                      });
                    }}
                  >
                    <IconEdit size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>

                <Menu>
                  <Menu.Target>
                    <Tooltip label="Xóa">
                      <ActionIcon
                        variant="light"
                        aria-label="Settings"
                        color="red"
                      >
                        <IconTrash size={20} stroke={1.5} />
                      </ActionIcon>
                    </Tooltip>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item leftSection={<IconX size={14} />}>Hủy</Menu.Item>
                    <Menu.Item
                      leftSection={<IconCheck size={14} />}
                      onClick={() => handleDelete([row.original.id])}
                    >
                      Xác nhận
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Box>
            ),
          },
        ],
      },
    ],
    [dataSubmit, name, dataEmployee, dataBranch, dataDepartment],
  );

  const fetchData = async (noti?: string) => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/AuthReportReading/get-list-auth-reading?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}&ApiKey=${code}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (
          value &&
          ((typeof value === "string" && value.length > 0) ||
            (typeof value === "number" && value > 0) ||
            (Array.isArray(value) && value.length > 0))
        ) {
          params.append(key, String(value));
        }
      });

      if (keySearch?.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryPos.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
        if (noti) {
          NotificationExtension.Success(noti);
        }
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleDelete = async (listId: string[]) => {
    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/AuthReportReading/delete-auth-reading",
      listId,
    );

    if (res && res.success) {
      NotificationExtension.Success("Xóa thành công !");
      fetchData("Xóa thành công !");
    } else {
      NotificationExtension.Fails("Có lỗi xảy ra khi xóa !");
    }
  };

  const fetchDataEmployee = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-all?departmentId=0",
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.id && item.code && item.fullname)
        ?.map((item: any) => ({
          label: `${item.code} - ${item.fullname}`,
          value: item.id?.toString(),
        }));
      setDataEmployee(data);
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value && item.att1)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.value,
        }));
      setDataBranch([{ label: "Tất cả", value: "-1" }, ...data]);
    }
  };

  const fetchDataDepartment = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDepartment/get-all",
    );

    if (res && res.success) {
      const result = res.data;
      // Nhiều chi nhánh có phòng ban trùng tên, ghép thêm tên chi nhánh để phân biệt
      const data = result
        ?.filter(
          (item: any) => item.departmentId && item.name && item.deparmentCode,
        )
        ?.map((item: any) => ({
          label: `[${item.attribute1}] - ${item.deparmentCode} - ${item.name}`,
          value: item.departmentId?.toString(),
        }));
      setDataDepartment([{ label: "Tất cả", value: "-1" }, ...data]);
    }
  };

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [deleteViewStatus, sorting, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    Promise.all([
      fetchDataEmployee(),
      fetchDataBranch(),
      fetchDataDepartment(),
    ]);
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (275 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    createDisplayMode: "row", // ('modal', and 'custom' are also available)
    editDisplayMode: isEdit ? "row" : "custom", // ('modal', 'row', 'cell', and 'custom' are also available)
    enableEditing: true,
    enableTopToolbar: false,
    enableRowNumbers: true,
    renderRowActions: () => <></>,
    //add custom action buttons to top-left of top toolbar

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    onCreatingRowCancel: () => {
      setDataSubmit({});
    },
    onCreatingRowSave: async ({ exitCreatingMode, values, table }) => {
      try {
        const response = await repositoryPos.post<MessageResponse<any>>(
          "/api/v1/AuthReportReading/add-auth-reading",
          {
            id: "0",
            empId: dataSubmit?.empId,
            apiKey: code,
            listBranchId: dataSubmit?.listBranchId?.join(","),
            listDepartmentId: dataSubmit?.listDepartmentId?.join(","),
            typeRole: null,
            attribute1: null,
            attribute2: null,
            attribute3: null,
            attribute4: null,
            attribute5: null,
            attribute6: null,
            attribute7: null,
            attribute8: null,
            attribute9: null,
            attribute10: null,
            createDate: null,
            createBy: null,
            lastUpdateDate: null,
            lastUpdateBy: null,
          },
        );
        if (response && response.success) {
          NotificationExtension.Success("Tạo mới thành công!");
          exitCreatingMode();
          setDataSubmit({});
          fetchData("Tạo mới thành công!");
        }
      } catch (error) {
        NotificationExtension.Fails("Có lỗi xảy ra khi tạo mới !");
      }
    },
    onEditingRowCancel: () => {
      setIsEdit(false);
    },
    onEditingRowSave: async ({ exitEditingMode, values, table }) => {
      try {
        const response = await repositoryPos.post<MessageResponse<any>>(
          "/api/v1/AuthReportReading/edit-auth-reading",
          {
            ...dataSubmit,
            listBranchId: dataSubmit?.listBranchId?.join(","),
            listDepartmentId: dataSubmit?.listDepartmentId?.join(","),
            attribute1: null,
          },
        );
        if (response && response.success) {
          NotificationExtension.Success("Chỉnh sửa thành công !");
          exitEditingMode();
          setDataSubmit({});
          setIsEdit(false);
          fetchData("Chỉnh sửa thành công !");
        }
      } catch (error) {
        NotificationExtension.Fails("Có lỗi xảy ra khi chỉnh sửa !");
      }
    },
    getRowId: (row) => row?.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-select"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: {
        pageIndex: 0,
        pageSize: 50,
      },
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "bold", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
        //  backgroundColor: row.original.userName.length>0 ? "white" : "gray",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "150"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });
  //#endregion
  return (
    <Box w={"87.5vw"} maw={1550}>
      <div className="mt-5">
        <div ref={headerRef} style={{ width: "100%" }}>
          <Flex
            gap="md"
            justify="space-between"
            align="center"
            direction="row"
            wrap="wrap"
            mt={5}
            w={"100%"}
          >
            <Grid mt={5} w={"80%"}>
              <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
                <TextInput
                  placeholder="Nhập từ khóa ..."
                  defaultValue={keySearch}
                  leftSection={<IconSearch color="#15AABF" />}
                  onChange={(e) => {
                    setKeySearch(e.currentTarget.value ?? "");
                  }}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
                <Select
                  placeholder="Nhập tên hoặc mã nhân viên"
                  data={dataEmployee}
                  leftSection={<IconUser color="#15AABF" />}
                  onChange={(e) =>
                    changeSearchValue(e ? e : "", "EmpId", setSearch)
                  }
                  searchable
                  clearable
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
                <Select
                  placeholder="Nhập mã hoặc tên chi nhánh"
                  data={dataBranch}
                  leftSection={<IconBrandBootstrap color="#15AABF" />}
                  onChange={(e) =>
                    changeSearchValue(e ? e : "", "BranchId", setSearch)
                  }
                  searchable
                  clearable
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
                <Select
                  placeholder="Nhập mã hoặc tên phòng ban"
                  data={dataDepartment}
                  leftSection={<IconBuildingSkyscraper color="#15AABF" />}
                  onChange={(e) =>
                    changeSearchValue(e ? e : "", "DepartmentId", setSearch)
                  }
                  searchable
                  clearable
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
            <Flex gap={"md"}>
              <Button
                leftSection={<IconTrash size={14} />}
                color="red"
                onClick={() => handleDelete(selectIds)}
                disabled={selectIds.length === 0}
              >
                Xóa
              </Button>
              <Button
                leftSection={<IconPlus size={14} />}
                color="teal"
                onClick={() => {
                  table.setCreatingRow(true);
                }}
              >
                Tạo mới
              </Button>
            </Flex>
          </Flex>
        </div>
        <Box mt={10}>
          <MantineReactTable table={table} />
        </Box>
      </div>
    </Box>
  );
};

export default DecentralizationReport;
